<template>
  <b-modal
    :visible="show"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closed')"
    size="md"
  >
    <div class="text-center py-3">
      <div class="mb-4">
        <b-icon-exclamation-triangle
          variant="warning"
          font-scale="6"
        ></b-icon-exclamation-triangle>
      </div>
      <h3 class="font-weight-bold mb-3">ลบหนังสือหรือไม่?</h3>
      <p v-if="book">
        หนังสือ {{ book.book_code }} {{ book.book_name }}
      </p>
      <p v-if="book && book.usedInCourses && book.usedInCourses.length > 0" class="mb-3">
        ถูกใช้ในคอร์ส {{ book.usedInCourses.join(', ') }}<br />
        การลบหนังสือจะทำให้คอร์สข้างต้นไม่สามารถเข้าถึงหนังสือเล่มนี้ได้
      </p>
    </div>

    <div>
      <div class="w-100 d-flex justify-content-center mb-4">
        <b-button variant="outline-secondary" class="mr-2" @click="$emit('closed')">
          ยกเลิก
        </b-button>
        <b-button variant="danger" @click="$emit('confirm')">
          ลบ
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "DeleteBookModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    book: {
      type: Object,
      default: null,
    },
  },
};
</script>
